/* eslint-disable camelcase */
import { createReducer } from "reduxsauce";
import { CollegeContentTypes as Types } from "../actions";
import storeInitialState from "../store/initial-state";

export const INITIAL_STATE = storeInitialState.collegeContent;

const replacePack = (packs, updatedPack) => {
  const exists = packs.some(pack => pack.id === updatedPack.id);

  if (!exists) return [...packs, updatedPack];

  return packs.map(pack =>
    pack.id === updatedPack.id ? updatedPack : pack,
  );
};

export const getContentPacksRequest = state => ({
  ...state,
  loading: true,
});
export const getContentPacksFailure = state => ({
  ...state,
  loading: false,
});
export const getContentPacksSuccess = (state, action) => ({
  ...state,
  loading: false,
  packs: action.data.content_packs || [],
  contentTypeOptions: action.data.content_type_options || [],
  sourceTypeOptions: action.data.source_type_options || [],
});

export const createContentPackRequest = state => ({
  ...state,
  saving: true,
});
export const createContentPackFailure = state => ({
  ...state,
  saving: false,
});
export const createContentPackSuccess = (state, action) => ({
  ...state,
  saving: false,
  editingPackId: null,
  isFormVisible: false,
  packs: replacePack(state.packs, action.data.content_pack),
});

export const updateContentPackRequest = state => ({
  ...state,
  saving: true,
});
export const updateContentPackFailure = state => ({
  ...state,
  saving: false,
});
export const updateContentPackSuccess = (state, action) => ({
  ...state,
  saving: false,
  editingPackId: null,
  isFormVisible: false,
  packs: replacePack(state.packs, action.data.content_pack),
});

export const deleteContentPackRequest = state => ({
  ...state,
  saving: true,
});
export const deleteContentPackFailure = state => ({
  ...state,
  saving: false,
});
export const deleteContentPackSuccess = (state, action) => ({
  ...state,
  saving: false,
  packs: state.packs.filter(pack => pack.id !== action.packId),
});

export const publishContentPackRequest = state => ({
  ...state,
  saving: true,
});
export const publishContentPackFailure = state => ({
  ...state,
  saving: false,
});
export const publishContentPackSuccess = (state, action) => ({
  ...state,
  saving: false,
  packs: replacePack(state.packs, action.data.content_pack),
});

export const unpublishContentPackRequest = publishContentPackRequest;
export const unpublishContentPackFailure = publishContentPackFailure;
export const unpublishContentPackSuccess = publishContentPackSuccess;

export const getContentTagsRequest = state => ({ ...state });
export const getContentTagsFailure = state => ({ ...state });
export const getContentTagsSuccess = (state, action) => ({
  ...state,
  tags: action.data.content_tags || [],
});

export const editContentPack = (state, action) => ({
  ...state,
  editingPackId: action.packId,
  isFormVisible: true,
});

export const closeContentPackForm = state => ({
  ...state,
  editingPackId: null,
  isFormVisible: false,
});

export const HANDLERS = {
  [Types.GET_CONTENT_PACKS_REQUEST]: getContentPacksRequest,
  [Types.GET_CONTENT_PACKS_FAILURE]: getContentPacksFailure,
  [Types.GET_CONTENT_PACKS_SUCCESS]: getContentPacksSuccess,

  [Types.CREATE_CONTENT_PACK_REQUEST]: createContentPackRequest,
  [Types.CREATE_CONTENT_PACK_FAILURE]: createContentPackFailure,
  [Types.CREATE_CONTENT_PACK_SUCCESS]: createContentPackSuccess,

  [Types.UPDATE_CONTENT_PACK_REQUEST]: updateContentPackRequest,
  [Types.UPDATE_CONTENT_PACK_FAILURE]: updateContentPackFailure,
  [Types.UPDATE_CONTENT_PACK_SUCCESS]: updateContentPackSuccess,

  [Types.DELETE_CONTENT_PACK_REQUEST]: deleteContentPackRequest,
  [Types.DELETE_CONTENT_PACK_FAILURE]: deleteContentPackFailure,
  [Types.DELETE_CONTENT_PACK_SUCCESS]: deleteContentPackSuccess,

  [Types.PUBLISH_CONTENT_PACK_REQUEST]: publishContentPackRequest,
  [Types.PUBLISH_CONTENT_PACK_FAILURE]: publishContentPackFailure,
  [Types.PUBLISH_CONTENT_PACK_SUCCESS]: publishContentPackSuccess,

  [Types.UNPUBLISH_CONTENT_PACK_REQUEST]: unpublishContentPackRequest,
  [Types.UNPUBLISH_CONTENT_PACK_FAILURE]: unpublishContentPackFailure,
  [Types.UNPUBLISH_CONTENT_PACK_SUCCESS]: unpublishContentPackSuccess,

  [Types.GET_CONTENT_TAGS_REQUEST]: getContentTagsRequest,
  [Types.GET_CONTENT_TAGS_FAILURE]: getContentTagsFailure,
  [Types.GET_CONTENT_TAGS_SUCCESS]: getContentTagsSuccess,

  [Types.EDIT_CONTENT_PACK]: editContentPack,
  [Types.CLOSE_CONTENT_PACK_FORM]: closeContentPackForm,
};

export default createReducer(INITIAL_STATE, HANDLERS);
